import {doDelete, doGet, doPost, doPut} from './http.service'
import {Page} from "../types/Page";
import {User} from "../types/User";

export interface UsersFilter {
    page: number,
    size: number,
    sortKey: string,
    login: string,
    username: string,
    phone: string,
    withPremium: boolean,
    userType: string,
    sortOrder: 'asc'|'desc',
}

export function loadUsers(filter: UsersFilter) {
    return doGet<Page<User>>('/users', {params: filter});
}
export function loadUser(id:string) {
    return doGet<User>('/users/' + id);
}
export function updateUser(user: User) {
    return doPut<User>('/users/' + user.id, user);
}
export function createUser(proposal: User) {
    return doPost<User>('/users', proposal);
}
export function deleteUser(id: string) {
    return doDelete<void>('/users/' + id);
}